import * as Yup from 'yup';

export const BidCompanyValidation = Yup.object().shape({
    spvCountryId: Yup.number().typeError('f:validation.number').required('f:validation.required'),
    spvName: Yup.string().typeError('f:validation.string').required('f:validation.required'),
});
